export default __webpack_public_path__ + "static/media/6.a16654dc.png";